<template>
  <IdentificationUploadForm />
</template>

<script setup>
import { useTitle } from "@vueuse/core";
import IdentificationUploadForm from "@/components/forms/Identity/IdentificationUploadForm.vue";

useTitle("Banxa - Confirm your identity");
</script>
